export default {
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.xs;
        },
        isTablet() {
            return this.$vuetify.breakpoint.sm;
        },
        isDesktop() {
            return this.$vuetify.breakpoint.mdAndUp;
        }
    }
}